<template>
  <div class="menu">
    <template
      v-for="menuItem in menuItems"
      :key="menuItem.id"
    >
      <RouterLink
        class="menu-item"
        :to="{name: menuItem.id}"
        :class="{'router-link-active': menuItem.active}"
      >
        {{ t('country_analytics_view.' + menuItem.name) }}
      </RouterLink>
    </template>
    <ButtonNeutralSecondary
      v-if="activeRoute.fullPath.includes('analytics')"
      class="menu__button-download"
      size="large"
      :pressed="isChartFileLoading"
      @click="handleDownloadClick"
    >
      <div
        v-if="isChartFileLoading"
        class="loader"
      />
      <DownloadIcon v-else />
      {{ t('country_analytics_view.download_pdf') }}
    </ButtonNeutralSecondary>
  </div>
</template>

<script setup>
import {computed, defineProps, defineEmits} from "vue";
import {useRoute} from "vue-router/dist/vue-router";
import { t } from "@/controllerLK/GlobusLocalization";
import {analyticsRoutes} from "@/router/analytic-router";
import DownloadIcon from "@/components/Icons/DownloadIcon.vue";

defineProps({
  isChartFileLoading: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(["download-chart"]);

// emit в AnalyticsPage.
const handleDownloadClick = () => {
  emit("download-chart");
};

const activeRoute = useRoute();
const menuItems = computed( () => {
  return analyticsRoutes
      .filter( route => route.meta?.renderInMenu )
      .map ( route => ({ id: route.name, name: route.meta.menuName, active: route.name === activeRoute.name }));
});
</script>

<style lang="scss" scoped>
.menu-item {
  color: black;
  text-decoration: none;
  font-size: 14px;
  line-height: 24px;
  transition: .2s;
  position: relative;
  display: flex;
  align-items: center;
  height: 42px;
}

.router-link-active {
  color: #1890FF !important;
}

.menu {
  display: flex;
  align-items: center;
  gap: 25px;


  &__button {
    &-download {
      margin-left: auto !important;

      .loader {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 2px solid currentColor;
        border-top-color: transparent;
        animation: spin 2s linear infinite;
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
